import React from 'react';
import { useDropdownToggle } from 'react-overlays/DropdownToggle';

export interface IDropdownToggleProps {
  children: React.ReactElement;
}

export const DropdownToggle: React.FC<IDropdownToggleProps> = ({ children }) => {
  const [props] = useDropdownToggle();

  return <>{React.cloneElement(children, props)}</>;
};
